<button class="fs-btn" type="button" (click)="toggle.emit()"
        [attr.aria-label]="isFullscreen
          ? (currLang === 'ar' ? 'تصغير' : 'Minimize')
          : (currLang === 'ar' ? 'ملء الشاشة' : 'Fullscreen')"
        [title]="isFullscreen
          ? (currLang === 'ar' ? 'تصغير' : 'Minimize')
          : (currLang === 'ar' ? 'ملء الشاشة' : 'Fullscreen')">
  <!-- Minimize: corner-in arrows -->
  <svg *ngIf="isFullscreen" width="18" height="18" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M8 3v5H3"/><path d="M21 8h-5V3"/><path d="M16 21v-5h5"/><path d="M3 16h5v5"/>
  </svg>
  <!-- Fullscreen: corner-out arrows -->
  <svg *ngIf="!isFullscreen" width="18" height="18" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M3 8V3h5"/><path d="M16 3h5v5"/><path d="M21 16v5h-5"/><path d="M8 21H3v-5"/>
  </svg>
  <span class="fs-label">{{ isFullscreen
    ? (currLang === 'ar' ? 'تصغير' : 'Minimize')
    : (currLang === 'ar' ? 'ملء الشاشة' : 'Fullscreen') }}</span>
</button>
